/**
 * Whether /login should document-nav away because a session appeared.
 *
 * Password success uses LoginForm.onSuccess (not this).
 * Email/recovery visits are owned by AuthProvider /auth/confirm — /login must not
 * steal them to home after setSession clears the hash and sets currentUser.
 */
export function shouldAutoLeaveLoginForExistingSession(input: {
  isLoading: boolean
  hasUser: boolean
  /** True if this page load had #access_token / ?code / ?token_hash on first paint. */
  hadEmailCallbackOnMount: boolean
  alreadyLeft: boolean
}): boolean {
  if (input.alreadyLeft) return false
  if (input.isLoading) return false
  if (!input.hasUser) return false
  if (input.hadEmailCallbackOnMount) return false
  return true
}
